import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';

/**
 * Component that checks for version updates after app mounts.
 * Must be rendered inside toast provider context.
 */
export function VersionChecker() {
  const { toast } = useToast();

  useEffect(() => {
    const currentVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content');
    if (!currentVersion) return;

    const storedVersion = localStorage.getItem('app-version');

    // First visit or version changed
    if (storedVersion && storedVersion !== currentVersion) {
      console.log('[Version Check] Version changed:', storedVersion, '→', currentVersion);
      
      toast({
        title: "Update Available",
        description: "A new version is available. Please refresh to get the latest features.",
        duration: 10000,
      });
    }

    // Update stored version
    localStorage.setItem('app-version', currentVersion);
  }, [toast]);

  return null; // This component doesn't render anything
}
